"use strict"
import React, {useEffect, useState} from "react"
import {observer} from "mobx-react"
import api from "../../global/actions/api"
import {Container, Grid, Typography, Hidden, Link} from "@material-ui/core"
import ReactTooltip from "react-tooltip"
import {FormattedMessage, injectIntl} from "react-intl"
import XsInput from "../../global/ui/xsInput/xsInput"
import XsAutocomplete from "../../global/ui/xsInput/xsAutocomplete"
import XsNumberInput from "../../global/ui/xsInput/xsNumberInput"
import AddIcon from "@material-ui/icons/Add"
import XsTextArea from "../../global/ui/xsTextArea/xsTextArea"
import GlobalStore from "../../global/store/GlobalStore"
import XsConfirmationDialog from "../../global/ui/xsDialog/xsConfirmationDialog"
import XsButton from "../../global/ui/xsButton/xsButton"
import XsChipForm from "../../global/ui/xsChipForm/xsChipForm"
import XsChip from "../../global/ui/xsChip/xsChip"
import XsIconButton from "../../global/ui/xsButton/xsIconButton"
import InfoStore from "../../global/store/InfoStore"
import RequestFormStore from "./RequestFormStore"
import RouterStore from "../../global/store/RouterStore"
import XsSearchSelect from "../../global/ui/xsSearchSelect/xsSearchSelect"
import RequestPrintStore from "./RequestPrintStore"
import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"
import renderHTML from "react-render-html"
import {isIBANValid, isPhoneNumberValid} from "../../global/helpers/functions"
import moment from "moment"
import Dropzone from "react-dropzone"

function IP_EICA_225(props) {
	const {form, hasHelpError} = props
	const [showIbanError, setShowIbanError] = useState(false)
	const requiredAttachemnts = ["price", "contractScan", "bankAccountScan", "documentsForEligibility"]

	const handleCorespondingAddressValidation = () => {
		if (form.$("companyAddressSameNo").value == true) {
			form.$("companyCorrespondenceRegion").set("rules", "required")
			form.$("companyCorrespondenceStreet").set("rules", "required")
			form.$("companyCorrespondenceCity").set("rules", "required")
			form.$("companyCorrespondenceStreetNumber").set("rules", "required")
			form.$("companyCorrespondencePSC").set("rules", "required|between:5,5")
		} else {
			form.$("companyCorrespondenceRegion").set("value", "")
			form.$("companyCorrespondenceStreet").set("value", "")
			form.$("companyCorrespondenceCity").set("value", "")
			form.$("companyCorrespondenceStreetNumber").set("value", "")
			form.$("companyCorrespondencePSC").set("value", "")

			form.$("companyCorrespondenceRegion").set("rules", "")
			form.$("companyCorrespondenceStreet").set("rules", "")
			form.$("companyCorrespondenceCity").set("rules", "")
			form.$("companyCorrespondenceStreetNumber").set("rules", "")
			form.$("companyCorrespondencePSC").set("rules", "")
		}
	}

	const isRegistrationClose = () => {
		if (isNotEmpty(form.$("callValidity").value)) {
			return moment().isAfter(moment(form.$("callValidity").value), "day")
		} else {
			return false
		}
	}
	const isSaveButtonDisabled =
		form.$("status").value == "sent" ||
		GlobalStore.isRegistrationClose() ||
		isRegistrationClose() ||
		form.$("confirmCheckbox1").value == false ||
		form.$("confirmCheckbox2").value == false ||
		form.$("confirmCheckbox3").value == false ||
		form.$("confirmCheckbox4").value == false ||
		form.$("confirmCheckbox5").value == false ||
		form.$("confirmCheckbox6").value == false ||
		form.$("confirmCheckbox7").value == false ||
		form.$("confirmCheckbox8").value == false ||
		form.$("confirmCheckbox9").value == false

	const isFormDisabled = () => {
		return (
			Boolean(form.$("status").value != "inp" && isNotEmpty(form.$("status").value)) ||
			GlobalStore.isRegistrationClose()
		)
	}

	const handleDrop = (files, index, length) => {
		for (let fileIndex in files) {
			let file = files[fileIndex]
			if (file.size > 20971520) {
				GlobalStore.setNotificationMessage("Size limit exceeded!", null, "error")
				continue
			}
			if (RequestFormStore[`dropedFiles${index}`].length >= length) {
				GlobalStore.setNotificationMessage("Maximum number of files exceeded!", null, "error")
				continue
			}

			if (index != "Other") {
				if (index == 0) {
					file.databaseType = "priceComparison"
				}
			} else {
				file.databaseType = "General"
			}
			RequestFormStore[`dropedFiles${index}`].push(file)
		}
	}

	const handleDropzonePreview = (attachmentIndex, dropzoneIndex) => {
		var FileSaver = require("file-saver") // eslint-disable-line no-undef
		FileSaver.saveAs(
			RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex],
			RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex].name
			// isNotEmpty(form.$("zoIPNumber").value)
			// 	? form.$("zoIPNumber").value.replace("ZoIP", "CP")
			// 	:
		)
	}

	const handleDropzoneDelete = (attachmentIndex, dropzoneIndex) => {
		if (isSafe(RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex]._id)) {
			RequestFormStore.deleteLoadedAttachemnt(
				RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex]._id,
				dropzoneIndex,
				attachmentIndex
			)
		} else {
			RequestFormStore[`dropedFiles${dropzoneIndex}`].splice(attachmentIndex, 1)
		}
	}

	useEffect(() => {
		if (isSafe(GlobalStore.CL["adviceArea"]) && isEmpty(form.$("eligibleArea").value)) {
			const type = GlobalStore.CL["adviceArea"].find((row) => row.code === "IP-EICA-225-A")
			if (isSafe(type)) {
				logger("nastavujem eligibleArea", type)
				form.$("eligibleArea").value = type._id
				form.$("eligibleAreaCode").value = type.code
			}
		}
	}, [GlobalStore.CL["adviceArea"]])

	const filteredCompanySize = isFormDisabled()
		? GlobalStore.CL["companySize"]
		: isSafe(GlobalStore.CL["companySize"])
		? GlobalStore.CL["companySize"].filter((row) => row.code !== "small")
		: []

	const filteredActivityType = GlobalStore.CL["activityType"]
		? GlobalStore.CL["activityType"].filter((row) => row.call_type.code === "IP_EICA_225")
		: []

	const filteredAdviceArea = GlobalStore.CL["adviceArea"]
		? GlobalStore.CL["adviceArea"].filter((row) => row.call_type.code === "IP_EICA_225")
		: []

	return (
		<React.Fragment>
			<Container maxWidth="lg">
				<Container maxWidth="lg" className="request_form_fields">
					<Grid container spacing={2} className="pt-5">
						<Grid item xs={12}>
							<Typography variant="h4" align="center">
								Žiadosť o poskytnutie pomoci prostredníctvom Inovačnej poukážky (ŽoIP)
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h5">Identifikácia oprávneného Žiadateľa</Typography>
						</Grid>
						<Grid item xs={12} md={6} lg={3} data-tip data-for="companyName">
							<XsInput field={form.$("companyName")} disabled={true} />
							<ReactTooltip className="custom-tooltip-line-height" id="companyName">
								Obchodné meno spoločnosti už nie je možné zmeniť. Prípadná oprava bude vykonaná administrátorom SIEA pri
								posúdení podmienok ŽoIP.
							</ReactTooltip>
						</Grid>
						<Grid item xs={12} md={6} lg={3} data-tip data-for="ico">
							<XsNumberInput field={form.$("ico")} step={"1"} min={"1"} disabled={true} />
							<ReactTooltip className="custom-tooltip-line-height" id="ico">
								IČO spoločnosti už nie je možné zmeniť. Prípadná oprava bude vykonaná administrátorom SIEA pri posúdení
								podmienok ŽoIP.
							</ReactTooltip>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsNumberInput field={form.$("dic")} step={"1"} min={"1"} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} md={6} lg={3} data-tip data-for="icdph">
							<XsInput field={form.$("icdph")} disabled={isFormDisabled()} />
							<ReactTooltip className="custom-tooltip-line-height" id="icdph">
								V prípade, že máte IČ DPH, je potrebné ho uviesť. V prípade, že IČ DPH nemáte, je potrebné uviesť do
								bunky IČ DPH nulu.
							</ReactTooltip>
						</Grid>

						<Grid item xs={12} md={6} lg={3}>
							<XsSearchSelect
								field={form.$("companyDesc")}
								disabled={isFormDisabled()}
								items={GlobalStore.CL["companyType"]}
							/>
						</Grid>

						<Grid item xs={12} md={6} lg={3} /*data-tip data-for="companyLegalForm"*/>
							<XsSearchSelect
								field={form.$("companyLegalForm")}
								disabled={isFormDisabled()}
								items={GlobalStore.CL["legalForm"]}
								specialTooltip={
									"Ak ste vybrali možnosť Iný typ právnej formy, doplňte prosím informáciu o inom type v časti žiadosti Predmet ŽoIP - Opis inovačného projektu v poli Doplňujúce údaje."
								}
							/>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsSearchSelect field={form.$("companySize")} disabled={isFormDisabled()} items={filteredCompanySize} />
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2" style={{color: showIbanError ? "red" : "inherit"}}>
								IBAN zadajte prosím v tvare SKXX XXXX XXXX XXXX XXXX XXXX
							</Typography>
						</Grid>
						<Grid item xs={12} md={6} lg={6} data-tip data-for="companyIBANtooltip">
							<XsInput
								field={form.$("companyIBAN")}
								disabled={isFormDisabled()}
								regex={(val) => isIBANValid(val)}
								onChange={() => {
									let value = form.$("companyIBAN").value
									// If value is SK followed by 22 digits, no spaces
									if (/^SK\d{22}$/.test(value)) {
										// Insert spaces after every 4 characters, but not at the end
										value = value.replace(/(.{4})/g, "$1 ").trim()
										// Set the formatted value back to the form field
										form.$("companyIBAN").set(value)
									}
									// Validation
									if (!isIBANValid(form.$("companyIBAN").value) || isEmpty(form.$("companyIBAN").value)) {
										setShowIbanError(true)
									} else {
										setShowIbanError(false)
									}
								}}
							/>
							<ReactTooltip className="custom-tooltip-line-height" id="companyIBANtooltip">
								Uveďte IBAN Žiadateľa zhodný s číslom účtu uvedenom v Prílohe č.3. - Sken zmluvy o podnikateľskom účte.
							</ReactTooltip>
						</Grid>
					</Grid>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Typography variant="h6">Adresa sídla podnikania (v súlade s OR SR alebo ŽR SR)</Typography>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsSearchSelect
								field={form.$("companyRegion")}
								items={
									//Okrem BB to ma vlastnu ziadost
									form.$("callCode").value == "IP_SK_121" && isSafe(GlobalStore.CL["region"])
										? GlobalStore.CL["region"].filter((row) => row.code != "SK032")
										: GlobalStore.CL["region"]
								}
								required
								disabled={isFormDisabled()}
								onChange={() => {
									RequestFormStore.checkRegionAvailability(form)
									form.$("companyCity").value = ""
								}}
							/>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsAutocomplete
								field={form.$("companyCity")}
								minLengthForSearch="1"
								api={api.loadEntityCity}
								inputRenderer={(obj) => obj.name_ext}
								saveValue={(obj) => obj.code}
								disabled={isFormDisabled()}
								addSpecialFilter={() => {
									// if (isNotEmpty(form.$("companyCounty").value)) {
									// 	return [
									// 		{
									// 			associated_column: "county",
									// 			predicate: "=",
									// 			values: [
									// 				{
									// 					id_value: form.$("companyCounty").value
									// 				}
									// 			]
									// 		}
									// 	]
									// }
								}}
							/>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput field={form.$("companyStreet")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} md={6} lg={3} data-tip data-for="companyStreetNumberTooltip">
							<XsInput field={form.$("companyStreetNumber")} disabled={isFormDisabled()} />
							<ReactTooltip className="custom-tooltip-line-height" id="companyStreetNumberTooltip">
								Uveďte číslo v tvare, ako ho máte zapísané v ORSR alebo ŽRSR.
							</ReactTooltip>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsNumberInput field={form.$("companyPSC")} min={"1"} step={"1"} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2">Je adresa sídla zhodná s korešpondenčnou adresou?</Typography>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsCheckbox
								field={form.$("companyAddressSameYes")}
								disabled={isFormDisabled()}
								onChange={() => {
									form.$("companyAddressSameNo").value = false
									handleCorespondingAddressValidation()
								}}
							/>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsCheckbox
								field={form.$("companyAddressSameNo")}
								disabled={isFormDisabled()}
								onChange={() => {
									form.$("companyAddressSameYes").value = false
									handleCorespondingAddressValidation()
								}}
							/>
						</Grid>
						{form.$("companyAddressSameNo").value == true && (
							<React.Fragment>
								<Grid item xs={12}></Grid>
								<Grid item xs={12} md={6} lg={3}>
									<XsSearchSelect
										field={form.$("companyCorrespondenceRegion")}
										items={GlobalStore.CL["region"]}
										// required
										disabled={isFormDisabled()}
										onChange={() => {
											form.$("companyCorrespondenceCity").value = ""
										}}
									/>
								</Grid>
								<Grid item xs={12} md={6} lg={3}>
									<XsAutocomplete
										field={form.$("companyCorrespondenceCity")}
										minLengthForSearch="1"
										api={api.loadEntityCity}
										inputRenderer={(obj) => obj.name_ext}
										saveValue={(obj) => obj.code}
										disabled={isFormDisabled()}
									/>
								</Grid>
								<Grid item xs={12} md={6} lg={3}>
									<XsInput field={form.$("companyCorrespondenceStreet")} disabled={isFormDisabled()} />
								</Grid>
								<Grid item xs={12} md={6} lg={3}>
									<XsInput field={form.$("companyCorrespondenceStreetNumber")} disabled={isFormDisabled()} />
								</Grid>
								<Grid item xs={12} md={6} lg={3}>
									<XsNumberInput
										field={form.$("companyCorrespondencePSC")}
										min={"1"}
										step={"1"}
										disabled={isFormDisabled()}
									/>
								</Grid>
							</React.Fragment>
						)}
						<Grid item xs={12}>
							<Typography variant="h5">Štatutárny orgán Žiadateľa / Fyzická osoba Žiadateľa</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2">
								V prípade viacerých členov štatutárneho orgánu ich môžete pridať pomocou kliknutia na znamienko +
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsChipForm
								field={form.$("applicantChipForm")}
								label={" "}
								configuration={{
									header: {
										chipsRenderer: (key, dataRow, clickHandler) => (
											<XsChip
												key={key}
												label={
													isSafe(dataRow["name"]) && isNotEmpty(dataRow["name"]["value"])
														? dataRow["name"]["value"]
														: ""
												}
												onClick={(e) => clickHandler(false, e, key)}
											/>
										),
										addButtonRenderer: (clickHandler) => (
											<XsIconButton className="xs-default xs-outline" icon={<AddIcon />} onClick={clickHandler} />
										)
									},
									columns: [
										{
											name: "name",
											label: "Titul, Meno, Priezvisko, Titul",
											width: 5,
											validationRule: "required",
											renderer: (field) => <XsInput field={field} disabled={isFormDisabled()} forceRequired />
										},
										{
											name: "isStatutar",
											label: "Zmluvu IP podpíše",
											width: 5,
											validationRule: "required",
											type: "checkbox",
											renderer: (field) => (
												<XsCheckbox
													tooltipId={
														"Uveďte všetkých členov štatutárneho orgánu v zmysle OR SR a ŽR SR a označte člena/členov štatutárneho orgánu, ktorí konajú a podpisujú v mene Žiadateľa a bude/budú podpisovať Zmluvu IP."
													}
													showTooltipAsText={true}
													field={field}
													disabled={isFormDisabled()}
												/>
											)
										}
									],
									options: {
										disabled: isFormDisabled(),
										disableFirstRowDelete: true,
										isFormMode: true,
										isModalMode: false,
										hideButtons: true,
										startOpen: true,
										maxLength: 5,
										hideHeader: true,
										onFormOpen: () => {},
										onFormClose: () => {},
										onFormSave: (vals) => {
											RequestFormStore.applicantChipForm = vals
										}
									},
									data: RequestFormStore.applicantChipForm
								}}
							/>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h5" data-tip data-for="contactPersonText">
								Kontaktná osoba Žiadateľa
							</Typography>
							<ReactTooltip className="custom-tooltip-line-height" id="contactPersonText">
								Osoba, ktorá zabezpečuje komunikáciu vo veci všetkých aktivít národného projektu ZIVSE 2, ktorých sa
								bude Váš podnik zúčastňovať.
							</ReactTooltip>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput field={form.$("contactPersonName")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} md={6} lg={3} data-tip data-for="contactPersonPhoneTooltip">
							<XsInput
								field={form.$("contactPersonPhone")}
								disabled={isFormDisabled()}
								regex={(val) => isPhoneNumberValid(val)}
								onBlur={() => {
									const value = form.$("contactPersonPhone").value
									if (typeof value === "string" && value.includes(" ")) {
										const newValue = value.replace(/\s+/g, "")
										form.$("contactPersonPhone").set(newValue)
									}
								}}
							/>
							<ReactTooltip className="custom-tooltip-line-height" id="contactPersonPhoneTooltip">
								Telefónne číslo zadávajte bez medzier.
							</ReactTooltip>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput field={form.$("contactPersonMail")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h5">Predmet ŽoIP - Opis inovačného projektu</Typography>
						</Grid>
						<Grid item xs={12} md={6} lg={4} data-tip data-for="projectName">
							<XsInput
								field={form.$("projectName")}
								disabled={isFormDisabled() || form.$("callCode").value == "IP_IPCEI_121"}
								maxLength={300}
							/>
						</Grid>
						<React.Fragment>
							<Hidden only={["sm", "xs"]}>
								<Grid item xs={1} md={6} lg={9}>
									<div></div>
								</Grid>
							</Hidden>
							<Grid item xs={12} md={6} lg={4}>
								<XsSearchSelect
									field={form.$("eligibleArea")}
									disabled={true}
									items={filteredAdviceArea || []}
									onChange={(value) => {
										const type = GlobalStore.CL["adviceArea"].find((row) => row._id == value)
										form.$("eligibleAreaCode").value = type.code
									}}
								/>
							</Grid>
						</React.Fragment>
						<Grid item xs={12} md={12} lg={12} data-tip data-for="legitimateActivitiesTooltip">
							<XsSearchSelect
								field={form.$("legitimateActivities")}
								isMulti={true}
								disabled={isFormDisabled()}
								items={filteredActivityType || []}
							/>
							<ReactTooltip className="custom-tooltip-line-height" id="legitimateActivitiesTooltip">
								Zvoľte výberom aj viaceré - všetky vami plánované aktivity
							</ReactTooltip>
						</Grid>

						<Grid item xs={12} md={12} lg={12}>
							<XsTextArea
								field={form.$("projectDescAndTarget")}
								disabled={isFormDisabled() || form.$("callCode").value == "IP_IPCEI_121"}
								maxLength={1500}
								onChange={() => {
									if (form.$("projectDescAndTarget").value.includes("<img src=")) {
										GlobalStore.setNotificationMessage("Vložte vstup bez obrázka!", null, "error")
										form.$("projectDescAndTarget").value = ""
									}
								}}
								tooltip={renderHTML(
									`Povinne definujte cieľ projektu a aké budú jeho prínosy. <br/>
									Definujte súlad inovačného projektu s definovanou oblasťou a aktivitou.<br/>
									Popíšte činnosti, prostredníctvom ktorých sa bude realizovať oprávnená oblasť a aktivita. <br/>
									Stručne popíšte riešenie a uveďte cieľ po zrealizovaní projektu. <br/>
									V čom je vaše riešenie unikátne a inovatívne a aký prínos inovácia prináša pre Žiadateľa/zákazníka?
                                    `
								)}
							/>
						</Grid>
						<React.Fragment>
							<Grid item xs={12} md={12} lg={12}>
								<XsTextArea
									field={form.$("projectBasicParameters")}
									maxLength={1500}
									disabled={isFormDisabled()}
									onChange={() => {
										if (form.$("projectBasicParameters").value.includes("<img src=")) {
											GlobalStore.setNotificationMessage("Vložte vstup bez obrázka!", null, "error")
											form.$("projectBasicParameters").value = ""
										}
									}}
									tooltip={renderHTML(
										`Popíšte východiskovú situáciu vo vzťahu k predkladanému inovačnému projektu, resp. vstupom, ktoré ovplyvňujú<br/>
										 realizáciu inovačného projektu, identifikované problémy a potreby. <br/>
										 Uveďte základné funkcie, prípadne technológie, ktoré budú využívané. <br/>
										 Do akej miery vedie inovačný projekt k tvorbe inovatívnych výrobkov, služieb a technológií? <br/>
										`
									)}
								/>
							</Grid>
							<Grid item xs={12} md={12} lg={12}>
								<XsTextArea
									field={form.$("projectImplementationMethod")}
									maxLength={1500}
									disabled={isFormDisabled()}
									onChange={() => {
										if (form.$("projectImplementationMethod").value.includes("<img src=")) {
											GlobalStore.setNotificationMessage("Vložte vstup bez obrázka!", null, "error")
											form.$("projectImplementationMethod").value = ""
										}
									}}
									tooltip={renderHTML(
										`Uveďte prípadné podmienky realizácie zmluvy, okrem lehoty plnenia a miesta realizácie uvádzaných nižšie. <br/>
										Môžete zároveň uviesť: predpokladaný spôsob realizácie aktivity projektu; charakteristiku projektu, riziká riešenia <br/>
										(ak sú známe), prínosy riešenia; situáciu po realizácii projektu; očakávané výsledky a ako dôjde po realizácii projektu <br/>
										k vyriešeniu problémov identifikovaných v popise východiskovej situácie; očakávané praktické využitie výsledkov <br/>
										projektu; potenciál zmeny pozície na trhu po uvedení inovácie; vplyv na národné hospodárstvo spolu s <br/>
										kvantifikáciou (zvýšenie vývozu, možnosti ďalšieho rozvoja a iné). <br/>

										`
									)}
								/>
							</Grid>
							<Grid item xs={12} md={12} lg={12}>
								<XsTextArea
									field={form.$("projectRealizationPlace")}
									maxLength={500}
									disabled={isFormDisabled()}
									onChange={() => {
										if (form.$("projectRealizationPlace").value.includes("<img src=")) {
											GlobalStore.setNotificationMessage("Vložte vstup bez obrázka!", null, "error")
											form.$("projectRealizationPlace").value = ""
										}
									}}
									tooltip={renderHTML(
										`Povinne uveďte všetky miesta realizácie. <br/>
										Pokiaľ Žiadateľ v tomto čase ešte nevie špecifikovať miesto realizácie, uvedie ako miesto realizácie územie SR. <br/>
										V prípade ak prebieha riešenie projektu s riešiteľom so sídlom mimo územia SR, Žiadateľ uvádza miesto realizácie <br/>
										napr. „v sídle riešiteľa“. <br/>
										`
									)}
								/>
							</Grid>
							<Grid item xs={12} md={12} lg={12}>
								<XsTextArea
									field={form.$("projectDeadlineCompletion")}
									maxLength={500}
									disabled={isFormDisabled()}
									onChange={() => {
										if (form.$("projectDeadlineCompletion").value.includes("<img src=")) {
											GlobalStore.setNotificationMessage("Vložte vstup bez obrázka!", null, "error")
											form.$("projectDeadlineCompletion").value = ""
										}
									}}
									tooltip={renderHTML(
										`Povinne definujte lehotu plnenia, ktorá nemôže prekročiť 6 mesiacov od vystavenia IP.`
									)}
								/>
							</Grid>
							<Grid item xs={12} md={12} lg={12}>
								<XsTextArea
									field={form.$("projectAdditionalInfo")}
									maxLength={5000}
									disabled={isFormDisabled()}
									onChange={() => {
										if (form.$("projectAdditionalInfo").value.includes("<img src=")) {
											GlobalStore.setNotificationMessage("Vložte vstup bez obrázka!", null, "error")
											form.$("projectAdditionalInfo").value = ""
										}
									}}
									tooltip={renderHTML(
										`Tu uveďte akékoľvek doplňujúce údaje, ktoré je potrebné uviesť vo vzťahu k potenciálnemu riešiteľovi inovačného <br/>
										projektu a k Opisu inovačného projektu pre zhotovenie cenovej ponuky, prípadne ostatné údaje potrebné k <br/>
										dostatočnosti popisu inovačného projektu.<br/>
										`
									)}
								/>
							</Grid>
							<Grid item xs={12} md={12} lg={12}>
								<XsTextArea
									field={form.$("oneCompanySubjectsIdentification")}
									maxLength={5000}
									disabled={isFormDisabled()}
									onChange={() => {
										if (form.$("oneCompanySubjectsIdentification").value.includes("<img src=")) {
											GlobalStore.setNotificationMessage("Vložte vstup bez obrázka!", null, "error")
											form.$("oneCompanySubjectsIdentification").value = ""
										}
									}}
									tooltip={renderHTML(`
										Jediný podnik - zahŕňa všetky subjekty vykonávajúce hospodársku činnosť, medzi ktorými je aspoň jeden z týchto <br/>
										vzťahov: <br/>
										a) jeden subjekt vykonávajúci hospodársku činnosť má väčšinu hlasovacích práv akcionárov alebo spoločníkov v <br/>
										inom subjekte vykonávajúcom hospodársku činnosť; <br/>
										b) jeden subjekt vykonávajúci hospodársku činnosť má právo vymenovať alebo odvolať väčšinu členov správneho, <br/>
										riadiaceho alebo dozorného orgánu iného subjektu 
										vykonávajúceho hospodársku činnosť; <br/>
										c) jeden subjekt vykonávajúci hospodársku činnosť má právo dominantným spôsobom ovplyvňovať iný subjekt <br/>
										vykonávajúci hospodársku činnosť na základe zmluvy, ktorú s daným subjektom vykonávajúcim hospodársku činnosť<br/>
										uzavrel, alebo na základe ustanovenia v zakladajúcom dokumente alebo stanovách spoločnosti; <br/>
										d) jeden subjekt vykonávajúci hospodársku činnosť, ktorý je akcionárom alebo spoločníkom iného subjektu <br/>
										vykonávajúceho hospodársku činnosť, má sám na základe zmluvy s inými akcionármi alebo spoločníkmi daného subjektu vykonávajúceho hospodársku <br/>
										činnosť pod kontrolou väčšinu hlasovacích práv akcionárov alebo spoločníkov v danom subjekte vykonávajúcom hospodársku činnosť.<br/>
										Subjekty vykonávajúce hospodársku činnosť, medzi ktorými sú typy vzťahov uvedené v písm. a) až d) predchádzajúceho odseku <br/>
										 prostredníctvom jedného alebo viacerých iných subjektov vykonávajúcich hospodársku činnosť, sa takisto považujú za jediný podnik. <br/>
										Definícia jediného podniku uvedená v Schéme pomoci de minimis na podporu zvyšovania výskumných a <br/>
										inovačných kapacít v podnikoch a rozvoja sieťovania aktérov inovačného ekosystému DM - 18/2024 v znení dodatku č. 1
										`)}
								/>
							</Grid>
							<Grid item container xs={12} md={12} lg={12}>
								{/* <XsTextArea
									field={form.$("otherSourcesSupport")}
									subTitle={`Poberáte alebo poberali ste pomoc de minimis v priebehu obdobia troch rokov predchádzajúcich deň predloženia ŽoIP? Ak áno, uveďte aké a v akej sume. (Prijatú pomoc de minimis Žiadateľ nájde v Informačnom systéme pre evidenciu a monitoring pomoci (IS SEMP), verejne dostupnom v elektronickej podobe na stránke https://semp.kti2dc.sk/ )`}
									maxLength={5000}
									disabled={isFormDisabled()}
									onChange={() => {
										if (form.$("otherSourcesSupport").value.includes("<img src=")) {
											GlobalStore.setNotificationMessage("Vložte vstup bez obrázka!", null, "error")
											form.$("otherSourcesSupport").value = ""
										}
									}}
									tooltip={renderHTML(`otherSourcesSupport`)}
								/> */}
								<Grid item xs={12}>
									<Typography variant="body2" style={{color: hasHelpError ? "red" : "inherit"}}>
										<b>Pomoc z iných schém pomoci de minimis *</b>
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="body2" style={{color: hasHelpError ? "red" : "inherit"}}>
										Žiada Žiadateľ v čase podania tejto ŽoIP o inú pomoc de minimis aj od iného poskytovateľa pomoci, v
										rámci iných schém pomoci de minimis?
									</Typography>
								</Grid>
								<Grid item md={2} xs={6}>
									<XsCheckbox
										field={form.$("otherSourcesSupportCheckboxYes")}
										disabled={isFormDisabled()}
										onChange={() => {
											form.$("otherSourcesSupportCheckboxYes").value = true
											form.$("otherSourcesSupportCheckboxNo").value = false
										}}
									/>
								</Grid>
								<Grid item md={2} xs={6}>
									<XsCheckbox
										field={form.$("otherSourcesSupportCheckboxNo")}
										disabled={isFormDisabled()}
										onChange={() => {
											form.$("otherSourcesSupportCheckboxYes").value = false
											form.$("otherSourcesSupportCheckboxNo").value = true
										}}
									/>
								</Grid>
							</Grid>
						</React.Fragment>
						<Grid item xs={12}>
							<Typography variant="h5">
								Identifikácia potenciálneho riešiteľa s najnižšou cenovou ponukou/oprávneného riešiteľa
							</Typography>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput field={form.$("potentialSolverName")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsNumberInput field={form.$("potentialSolverIco")} step={"1"} min={"1"} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsNumberInput field={form.$("potentialSolverDic")} step={"1"} min={"1"} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput field={form.$("potentialSolverIcdph")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} md={6} lg={4}>
							<XsNumberInput
								field={form.$("potentialSolverCompletePrice")}
								step={"0.01"}
								min={"1"}
								disabled={isFormDisabled()}
								endText={"€"}
							/>
						</Grid>
						<Grid item xs={12} md={6} lg={4} data-tip data-for="potentialSolverVoucherPriceTooltip">
							<XsNumberInput
								field={form.$("potentialSolverVoucherPrice")}
								step={"0.01"}
								min={"1"}
								disabled={isFormDisabled()}
								endText={"€"}
							/>
							<ReactTooltip className="custom-tooltip-line-height" id="potentialSolverVoucherPriceTooltip">
								Výška zadávanej sumy musí byť v rozmedzí: minimum 2 000,00 € a maximum 20 000,00 €.
							</ReactTooltip>
						</Grid>
						<Grid item xs={12} md={6} lg={4}>
							<XsNumberInput
								field={form.$("potentialSolverCofinancedPrice")}
								step={"0.01"}
								min={"1"}
								disabled={isFormDisabled()}
								endText={"€"}
							/>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2">
								1) V súlade s údajom vo formulári Vyhodnotenie cenového prieskumu <br />
								2) Výšku Inovačnej poukážky stanovuje Žiadateľ v súlade s Príručkou, kapitolou 2.4 Stanovenie výšky
								oprávnených výdavkov
								<br />
								3) Žiadateľ uvádza vlastné spolufinancovanie spolu s neoprávnenými výdavkami hradenými z vlastných
								zdrojov (ak relevantné)
							</Typography>
						</Grid>
						<Grid item xs={12} style={{marginTop: "50px"}}>
							<Typography variant="h5" align="center">
								Vyhlásenie Žiadateľa o splnení podmienok účasti v Schéme pomoci de minimis na podporu zvyšovania
								výskumných a inovačných kapacít v podnikoch a rozvoja sieťovania aktérov inovačného ekosystému{" "}
								<Typography variant="inherit" style={{whiteSpace: "nowrap"}}>
									DM - 18/2024 v znení dodatku č. 1
								</Typography>
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								1. Vyhlasujem, že ku dňu podania ŽoIP som fyzická alebo právnická osoba podľa § 2 ods. 2 zákona č.
								513/1991 Zb. Obchodný zákonník v znení neskorších predpisov, ktorá je registrovaná a vykonáva
								podnikateľskú činnosť v rámci Slovenskej republiky.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox1")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								2. Vyhlasujem, že ku dňu podania ŽoIP mi nebola preplatená Inovačná poukážka v rámci iných výziev NP
								ZIVSE2.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox2")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								3. Vyhlasujem, že krátky návrh (short proposal) bol predložený po 1. januári 2024 a Žiadateľ nezískal
								tri zamietavé hodnotenia („NO GO“) na ktorejkoľvek úrovni hodnotenia (krátky návrh, úplný návrh,
								prezentácia pred porotou EIC) v rámci programu EIC Accelerator po 1. januári 2024, čím potvrdzujem svoju
								oprávnenosť na predloženie úplnej žiadosti
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox3")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								4. Vyhlasujem, že ako oprávnený Žiadateľ disponujem skúsenosťami v oblasti zamerania Inovačného
								projektu.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox4")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								5. Vyhlasujem, že údaje uvedené v tejto ŽoIP a v Cenovom prieskume sú úplné, pravdivé a správne a boli
								poskytnuté slobodne a opis inovačného projektu, ktorý je súčasťou oslovenia potenciálnych riešiteľov na
								predloženie cenovej ponuky je totožný s opisom inovačného projektu v ŽoIP.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox5")} disabled={isFormDisabled()} />
						</Grid>

						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								6. Vyhlasujem a rozmumiem, že touto ŽoIP žiadam aj o poskytnutie komplexného online inovačného
								poradenstva nepriamou formou, ktorej pomoc nebude preplatená prostredníctvom Inovačnej poukážky a bude
								poskytnutá bezodplatne od SIEA.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox6")} disabled={isFormDisabled()} />
						</Grid>

						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								7. Vyhlasujem, že spĺňam podmienky uvedené v bode K) Schémy pomoci de minimis na podporu zvyšovania
								výskumných a inovačných kapacít v podnikoch a rozvoja sieťovania aktérov Inovačného ekosystému.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox7")} disabled={isFormDisabled()} />
						</Grid>

						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								8. Vyhlasujem, že sa voči mne neuplatňuje vrátenie štátnej pomoci na základe rozhodnutia Európskej
								komisie, v ktorom bola táto štátna pomoc označená za neoprávnenú a nezlučiteľnú s vnútorným trhom (ak
								Žiadateľ patrí do skupiny podnikov, predloží toto vyhlásenie za všetkých členov skupiny podnikov, ktoré
								s ním tvoria jediný podnik).
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox8")} disabled={isFormDisabled()} />
						</Grid>

						<Grid item xs={12}>
							<Typography variant="h6" style={{fontWeight: "400"}}>
								9. Vyhlasujem, že som si vedomý právnych následkov v prípade, že sa preukáže, že čestné vyhlásenie nie
								je pravdivé.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox isRequired field={form.$("confirmCheckbox9")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} style={{marginTop: "50px"}}>
							<Typography variant="h5">Súhlas na zasielanie marketingových informácií</Typography>
						</Grid>
						<Grid item xs={12}>
							Týmto udeľujem SIEA súhlas na zasielanie marketingových informácií a noviniek o službách a aktivitách SIEA
							a Národného projektu Zvýšenie inovačnej výkonnosti slovenskej ekonomiky 2 (ďalej len „NP ZIVSE2“), kód
							ITMS21+ : 401 101 A334, a to prostredníctvom elektronickej pošty na emailovú adresu uvedenú v tejto ŽoIP.
							Súhlas je udelený do 10 rokov od ukončenia doby udržateľnosti NP ZIVSE2 a je možné ho kedykoľvek odvolať
							zaslaním žiadosti na emailovú adresu&nbsp;
							<Link className="pointer" onClick={() => window.open("mailto:inovujme@siea.gov.sk ")}>
								inovujme@siea.gov.sk
							</Link>
							&nbsp;alebo zaslaním písomnej žiadosti na korešpondenčnú adresu SIEA.
						</Grid>

						<Grid item xs={12}>
							<XsCheckbox
								field={form.$("sentMarketingDataYes")}
								onChange={() => {
									form.$("sentMarketingDataYes").value = true
									form.$("sentMarketingDataNo").value = false
								}}
								disabled={isFormDisabled()}
							/>
						</Grid>
						<Grid item xs={12}>
							<XsCheckbox
								field={form.$("sentMarketingDataNo")}
								onChange={() => {
									form.$("sentMarketingDataYes").value = false
									form.$("sentMarketingDataNo").value = true
								}}
								disabled={isFormDisabled()}
							/>
						</Grid>
						<Grid item xs={12} style={{marginTop: "50px"}}>
							<Typography variant="h5">Povinné prílohy k ŽoIP</Typography>
						</Grid>
						<Grid item container>
							{isSafe(RequestFormStore.attachmentTemplates) &&
								RequestFormStore.attachmentTemplates
									.filter((row) => requiredAttachemnts.includes(row))
									.map((template, dropzoneIndex) => {
										return (
											<Grid item container spacing={2} key={dropzoneIndex} data-tip data-for={`${template}Tooltip`}>
												<Grid item xs={12}>
													{template === "price" && (
														<Typography>
															Príloha č.1 - Cenový prieskum, ktorý musí obsahovať náležitosti podľa Kap.2.3 Príručky.
														</Typography>
													)}
													{template === "contractScan" && (
														<Typography>Príloha č.2 – Sken Zmluvy OR podpísanej oboma zmluvnými stranami.</Typography>
													)}
													{template === "bankAccountScan" && (
														<Typography>
															Príloha č.3 - Sken Zmluvy o zriadení podnikateľského účtu Žiadateľa uzatvorenú s bankou
															alebo potvrdenie banky o zriadení podnikateľského účtu, na ktorý majú byť Žiadateľovi
															vyplácané prostriedky pomoci.
														</Typography>
													)}
													{template === "documentsForEligibility" && (
														<Typography>
															Príloha č. 4 - Dokument preukazujúci oprávnenosť Žiadateľa v zmysle Kap.3.1. (Správa o
															hodnotení krátkeho návrhu EIC Accelerator)
														</Typography>
													)}
												</Grid>
												<Grid item xs={12}>
													<Dropzone
														onDrop={(files) => {
															handleDrop(files, dropzoneIndex, 1)
														}}
														id="dropzone"
														disabled={isFormDisabled()}
														accept={".pdf"}
													>
														{isSafe(RequestFormStore[`dropedFiles${dropzoneIndex}`]) &&
														RequestFormStore[`dropedFiles${dropzoneIndex}`].length ? (
															RequestFormStore[`dropedFiles${dropzoneIndex}`].map((file, index) => (
																<div key={index} className={"dropedFile"}>
																	<i
																		className="fal fa-file icon"
																		onClick={(e) => {
																			e.stopPropagation()
																			handleDropzonePreview(index, dropzoneIndex)
																		}}
																	/>
																	<i
																		className="far fa-trash-alt deleteIcon"
																		onClick={(e) => {
																			e.stopPropagation()
																			if (!isFormDisabled()) {
																				GlobalStore.openConfirmationDialog("xsDeleteAttachmentFromDropzone", {
																					fileIndex: index,
																					dropzoneIndex: dropzoneIndex
																				})
																			}
																		}}
																	/>
																	<br />
																	<div
																		className={"mac_ellipsis"}
																		data-content-start={file.name.substr(0, Math.floor(file.name.length / 2))}
																		data-content-end={
																			"\u200E" + file.name.substr(Math.floor(file.name.length / 2)) + "\u200E"
																		}
																	/>
																</div>
															))
														) : (
															<div
																className={"dropzonePlaceholder"}
															>{`Nahrajte súbor jeho potiahnutím (drag and drop) alebo kliknite a vyberte z Vášho súborového systému`}</div>
														)}
													</Dropzone>
												</Grid>
											</Grid>
										)
									})}
						</Grid>
						<ReactTooltip className="custom-tooltip-line-height" id="priceTooltip">
							Na základe Príručky vložte prílohu: Cenový prieskum, výlučne vo formáte PDF - obsahujúci všetky strany
							skenovaných dokumentov.
						</ReactTooltip>
						<ReactTooltip className="custom-tooltip-line-height" id="contractScanTooltip">
							Na základe Príručky vložte prílohu: Sken Zmluvy OR, výlučne vo formáte PDF - obsahujúci všetky strany
							skenovaných dokumentov.
						</ReactTooltip>
						<ReactTooltip className="custom-tooltip-line-height" id="bankAccountScanTooltip">
							Na základe Príručky vložte prílohu: Sken Zmluvy o zradení podnikateľského účtu s bankou, výlučne vo
							formáte PDF - obsahujúci všetky strany skenovaných dokumentov.
						</ReactTooltip>
						<ReactTooltip className="custom-tooltip-line-height" id="documentsForEligibilityTooltip">
							Na základe Príručky vložte prílohu:Dokumenty preukazujúce oprávnenosť žiadateľa, výlučne vo formáte PDF -
							obsahujúci všetky strany skenovaných dokumentov.
						</ReactTooltip>
					</Grid>
				</Container>
				<Container maxWidth="lg" className="request_form_buttons" style={{marginTop: "15px"}}>
					<Grid item container spacing={1}>
						<Grid item>
							<XsButton
								icon={<i className="fal fa-save"></i>}
								onClick={() => {
									delayedCallback(300, () => {
										RequestFormStore.validateDraft(form, () => {
											RequestFormStore.generateDataAndSave(form, "draft", (id) => {
												RouterStore.push(`/request?id=${id}`)
												GlobalStore.loading(true)
												RequestFormStore.resetDropzones()
												form.reset()
												RequestFormStore.load(form, id)
											})
										})
									})
								}}
								disabled={
									!(form.$("status").value == "inp" || isEmpty(form.$("status").value)) ||
									GlobalStore.isRegistrationClose()
								}
								disableTextTransform
								text={"ULOŽIŤ ROZPRACOVANÚ ŽoIP"}
							/>
						</Grid>
						<Grid item data-tip data-for={"disabledSaveForm"}>
							<XsButton
								icon={<i className="fal fa-save"></i>}
								onClick={(e) => {
									delayedCallback(300, () => {
										form.onSubmit(e)
									})
								}}
								disabled={isSaveButtonDisabled}
								disableTextTransform
								text="ODOSLAŤ VYPRACOVANÚ ŽoIP"
							/>
							{isSaveButtonDisabled && (
								<ReactTooltip className="custom-tooltip-line-height" id="disabledSaveForm">
									Žiadosť nie je možné odoslať pokiaľ nevyplníte všetky povinné polia, vyhlásenia a prílohy.
								</ReactTooltip>
							)}
						</Grid>
						<Grid item>
							<XsButton
								disabled={form.$("status").value != "sent"}
								icon={<i className="fal fa-print"></i>}
								onClick={() => {
									delayedCallback(300, () => {
										RequestPrintStore.print(form)
										InfoStore.open(
											"Povoľte, prosím, vyskakovacie okno pre túto stránku ak sa nezobrazí nove okno / záložka s vygenerovaným pdf.",
											<FormattedMessage id="Common.label.warning" />
										)
									})
								}}
								variant="outlined"
								text={"STIAHNUŤ PDF ŽIADOSTI"}
							/>
						</Grid>
						<Grid item>
							{/* <XsButton
								// disabled={form.$("status").value != "sent"}
								icon={<i className="fal fa-print"></i>}
								onClick={() => {
									delayedCallback(300, () => {
										RequestPrintStore.generateExcel(form)
										InfoStore.open(
											"Povoľte, prosím, vyskakovacie okno pre túto stránku ak sa nezobrazí nove okno / záložka s vygenerovaným pdf.",
											<FormattedMessage id="Common.label.warning" />
										)
									})
								}}
								variant="outlined"
								text={"STIAHNUŤ EXCEL ŽIADOSTI"}
							/> */}
						</Grid>
						<Grid item>
							<XsButton
								icon={<i className="fal fa-times"></i>}
								onClick={() => {
									delayedCallback(300, () => {
										if (RequestFormStore.isSameFormValues()) {
											form.reset()
											RouterStore.push("/requests")
										} else {
											GlobalStore.openConfirmationDialog("xsCloseRequestForm")
										}
									})
								}}
								color="secondary"
								text={"ZATVORIŤ A ZRUŠIŤ ZMENY"}
							/>
						</Grid>
					</Grid>
				</Container>
			</Container>
			<XsConfirmationDialog
				name="xsDeleteAttachmentFromDropzone"
				title={"Pozor"}
				text={"Naozaj chcete odstrániť prílohu?"}
				onConfirmation={() =>
					handleDropzoneDelete(
						GlobalStore.confirmationDialogParams.fileIndex,
						GlobalStore.confirmationDialogParams.dropzoneIndex
					)
				}
			/>
		</React.Fragment>
	)
}

export default injectIntl(observer(IP_EICA_225))

